import React, { useState } from "react";
import RBACRolesTab from "./RBACRolesTab";
import RBACUserAttachTab from "./RBACUserAttachTab";

const RBACPanel = ({ callback = false }) => {
  const [activeTab, setActiveTab] = useState("roles");
  return (
    <div>
      {/* Tabs */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm mb-6">
        <div className="border-b border-gray-200">
          <nav className="flex -mb-px" aria-label="Tabs">
            <button
              onClick={() => setActiveTab("roles")}
              className={`
                px-6 py-4 text-sm font-medium border-b-2 transition-colors duration-200
                ${
                  activeTab === "roles"
                    ? "border-primary-500 text-primary-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }
              `}
            >
              RBAC Roles
            </button>
            <button
              onClick={() => setActiveTab("user-attach")}
              className={`
                px-6 py-4 text-sm font-medium border-b-2 transition-colors duration-200
                ${
                  activeTab === "user-attach"
                    ? "border-primary-500 text-primary-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }
              `}
            >
              RBAC User Attach
            </button>
          </nav>
        </div>
      </div>
      {activeTab === "roles" && <RBACRolesTab />}
      {activeTab === "user-attach" && <RBACUserAttachTab />}
    </div>
  );
};

export default RBACPanel;
